export default "__VITE_ASSET__043c9971__"